import React, { FunctionComponent } from "react";

export enum TagType {
  buy = "buy",
  lease = "lease",
  loan = "loan",
}

export const Tag: FunctionComponent<{ tagType: TagType; width?: string }> = ({
  tagType,
  width,
  children,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: width || "4rem",
        fontSize: "0.8rem",
        borderRadius: "3px",
        textAlign: "center",
        padding: "0.125rem 0.5rem",
        fontWeight: "500",
        background:
          tagType === TagType.buy
            ? "#FFF7CD"
            : tagType === TagType.lease
            ? "#E9F8E8"
            : "#FDF1F7",
        color:
          tagType === TagType.buy
            ? "#7E6A00"
            : tagType === TagType.lease
            ? "#5E7151"
            : "#70435A",
      }}
    >
      <div>{children || tagType.toUpperCase()}</div>
    </div>
  );
};
